import { useEffect, useState } from "react"
import api from "../lib/api";
import { Link } from "react-router-dom";
import { Lock, MapPin } from "lucide-react"
import { MapContainer } from "./map-container"
import { Card, CardContent } from "./ui/card"
import { Button } from "./ui/button"

export function PublicMapPreview() {
  const [stations, setStations] = useState([])
  const [loading, setLoading] = useState(true)
  const isLoggedIn = !!localStorage.getItem("token")

  useEffect(() => {
    // Only fetch if the user is authenticated — the endpoint now requires a JWT
    if (!isLoggedIn) {
      setLoading(false)
      return
    }

    async function fetchStations() {
      try {
        const { data } = await api.get("/api/stations");
        setStations(data);
      } catch (error) {
        console.error("Error fetching stations:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchStations()
  }, [isLoggedIn])

  // ── Guest view ──────────────────────────────────────────────────────────────
  if (!isLoggedIn) {
    return (
      <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[500px] bg-gradient-to-br from-[#0288d0]/10 to-[#0288d0]/5 flex items-center justify-center">
        {/* Blurred map hint */}
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <div className="w-full h-full bg-[url('https://api.mapbox.com/styles/v1/mapbox/light-v11/static/8.7742,3.7523,12,0/1200x500?access_token=pk.placeholder')] bg-cover bg-center" />
        </div>

        {/* Decorative pins */}
        <div className="absolute top-1/4 left-1/3 text-[#0288d0] opacity-40 animate-bounce" style={{ animationDelay: "0s" }}>
          <MapPin className="w-8 h-8" />
        </div>
        <div className="absolute top-1/2 left-1/2 text-[#0288d0] opacity-40 animate-bounce" style={{ animationDelay: "0.4s" }}>
          <MapPin className="w-6 h-6" />
        </div>
        <div className="absolute bottom-1/3 right-1/3 text-[#0288d0] opacity-40 animate-bounce" style={{ animationDelay: "0.8s" }}>
          <MapPin className="w-7 h-7" />
        </div>

        {/* Lock overlay card */}
        <Card className="relative z-10 max-w-md mx-4 shadow-xl">
          <CardContent className="p-8 text-center">
            <div className="w-16 h-16 bg-[#0288d0]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="w-8 h-8 text-[#0288d0]" />
            </div>
            <h3 className="text-2xl font-bold mb-3">Inicia sesión para acceder</h3>
            <p className="text-muted-foreground mb-6 text-pretty">
              Regístrate gratis para ver los puntos de venta en el mapa, consultar el stock en tiempo real
              y obtener direcciones.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/login">
                <Button variant="outline" className="w-full sm:w-auto bg-transparent">
                  Iniciar Sesión
                </Button>
              </Link>
              <Link to="/register">
                <Button className="bg-[#0288d0] hover:bg-[#0288d0]/90 w-full sm:w-auto">
                  Registrarse Gratis
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }

  // ── Loading state (authenticated) ───────────────────────────────────────────
  if (loading) {
    return (
      <div className="flex items-center justify-center h-[500px] bg-muted/20 rounded-2xl">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0288d0] mx-auto mb-4"></div>
          <p className="text-muted-foreground">Cargando mapa...</p>
        </div>
      </div>
    )
  }

  // ── Authenticated view — live map ────────────────────────────────────────────
  return (
    <div className="rounded-2xl overflow-hidden shadow-2xl h-[500px]">
      <MapContainer stations={stations} onStationSelect={() => {}} />
    </div>
  )
}